import request from '@/utils/request'

/**
 * 查询当前店铺配送方式配置
 * 说明：distribution_mode 无独立商户态查询服务码（原 distributionMode.listDistributionMode 为历史死码，
 * 后端全工程无任何 @UhangCmd 实现）；Task 21A 核查确认 shop.queryShop 响应内嵌 distributionModeDtos
 * （mapper 已别名 deliveryType），故本封装复用 shop.queryShop 并适配为列表返回结构。
 * @param {Object} params 查询参数（shopId 必填，建议 page=1, row=1 单店直查）
 * @returns {Promise} Promise对象，适配为 {data: 配送方式数组, total: 数组长度}
 */
export function listDistributionMode(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShop',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      let distributionModes = []
      if (res.data && res.data.length > 0 && res.data[0].distributionModeDtos) {
        // 过滤店铺无配置时后端填充的占位行（modeId=-1）
        distributionModes = res.data[0].distributionModeDtos.filter(
          item => item.modeId && item.modeId !== '-1'
        )
      }
      resolve({ data: distributionModes, total: distributionModes.length })
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改店铺配送方式配置（REQ20260904014 商户态服务码 shop.updateDistributionMode）
 * 定位规则：deliveryType 非空时按 shopId+deliveryType 精确唯一定位（一店每配送方一条）；
 * deliveryType 为空且该店存在多条配置时后端要求显式指定，故编辑弹窗中 deliveryType 必选。
 * 费用类字段传空字符串会被后端跳过（不改），-1 为域内「不适用」惯例值。
 * @param {Object} data 修改报文（{shopId, deliveryType, modeName?, fixedFee?, startDeliveryIn?, startDeliveryOut?, maximumDistribution?}）
 * @returns {Promise} Promise对象
 */
export function updateShopDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.updateDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
